import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  themeColumns,
  videoColumns,
} from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useStore } from "../../hooks/store";

import GridToolBar from "../GridToolBar";
import { getTheme } from "../../utils/API/themeMethods";
import { deletVideoData, getVideoData } from "../../utils/API/videoMethods";
import VideoForm from "../Form/VideoForm";

export function VideoGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [videoData, setVideoData] = useState(undefined);

  const fetchVideoData = () => {
    getVideoData().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    getTheme().then(({ data, status }) => {
      if (status !== 200) {
        return;
      }
      store.setForm(<VideoForm themeList={data} />, fetchVideoData);
    });
  };

  const handleRedactOpener = () => {
    getTheme().then(({ data, status }) => {
      if (status !== 200) {
        return;
      }
      store.setForm(<VideoForm themeList={data} />, fetchVideoData, videoData);
    });
  };

  const handleDelete = async () => {
    const { id } = videoData;
    const deletedVideo = await deletVideoData(id);
    if (deletedVideo.status !== 200) {
      store.setAlert(deletedVideo.data, "error");
      return;
    }
    fetchVideoData();
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchVideoData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setVideoData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchVideoData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={videoData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...videoColumns]}
      />
    </div>
  );
}
